import { Link } from "react-router-dom";
import SEOMeta from "../components/SEOMeta";

export default function NotFound() {
  return (
    <>
      <SEOMeta
        title="Página não encontrada | Inspira Músicas"
        description="Esta página não existe."
        path="/404"
        noIndex
      />
      <div
        style={{
          minHeight: '100vh',
          background: 'var(--cream)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          padding: '0 24px',
          fontFamily: "'DM Sans', sans-serif",
        }}
      >
        <p
          style={{
            fontSize: 96,
            fontWeight: 900,
            color: 'var(--beige-mid)',
            lineHeight: 1,
            marginBottom: 8,
            fontFamily: "'Playfair Display', serif",
          }}
        >
          404
        </p>
        <h1
          style={{
            fontSize: 24,
            fontWeight: 700,
            color: 'var(--earth)',
            marginBottom: 12,
            fontFamily: "'Playfair Display', serif",
          }}
        >
          Página não encontrada
        </h1>
        <p style={{ color: 'var(--text-muted)', fontSize: 16, marginBottom: 32, maxWidth: 360, lineHeight: 1.6 }}>
          O endereço que você acessou não existe. Mas ainda dá tempo de criar uma música incrível.
        </p>
        <Link
          to="/"
          style={{
            background: 'var(--gold)',
            color: '#fff',
            padding: '12px 32px',
            borderRadius: 100,
            textDecoration: 'none',
            fontSize: 15,
            fontWeight: 600,
          }}
        >
          Voltar ao início
        </Link>
      </div>
    </>
  );
}
